export default "__VITE_ASSET__DCUixaav__"